export default __webpack_public_path__ + "static/media/noorderpark.67104a07.jpg";